import React from "react";

import styles from "./Radio.module.scss";

/**
 * @param {Boolean} checked - whether or not the value is currently selected (checked)
 * @param {String} [className] - additional className to add
 * @param {String} [labelClassName] - additional className to add
 * @param {String} labelText - text shown next to option
 * @param {Function} onChange - function to run onChange event
 * @param {String} value - the value of the input element
 */
const Radio = ({
    disabled,
    checked,
    className,
    labelClassName,
    labelText,
    onChange,
    value
}) => {
    return (
        <label className={`${styles.radio} ${labelClassName || ""}`}>
            <input
                disabled={disabled || false}
                checked={checked}
                className={`${styles.hidden} ${className || ""}`}
                type="radio"
                value={value}
                onChange={onChange}
            />
            <span className={styles["radio-span"]} />
            {labelText
                ? labelText
                : labelText === false
                ? ""
                : "Add labelText prop"}
        </label>
    );
};

export default Radio;
